import React from 'react';
import cx from 'classnames';
import { IUserActionCount, useFormatActionCount } from './config';
import Styles from './mIndex.module.scss';

const UserActionCount = ({ className, count, size = 'md' }: IUserActionCount) => {
  const formattedCount = useFormatActionCount(count);

  return (
    <div className={cx(Styles.userActionCount, Styles[size], className)}>
      { formattedCount }
    </div>
  );
};

export default UserActionCount;
